import { createPortal } from "react-dom";
import { X, Trash2 } from "lucide-react";

export default function ConfirmDeleteModal({
  open,
  onClose,
  onConfirm,
  title = "Hapus Data",
  description = "Tindakan ini tidak dapat dibatalkan. Apakah kamu yakin ingin menghapus data ini secara permanen?",
  loading = false,
}) {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      
      {/* OVERLAY: Backdrop blur menggunakan portal memastikan tidak terpotong parent */}
      <div
        className="absolute inset-0 bg-slate-900/40 backdrop-md transition-opacity"
        onClick={onClose}
      />

      {/* MODAL CARD */}
      <div className="relative bg-white w-full max-w-sm rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* CLOSE BUTTON (Top Right) */}
        <button 
          onClick={onClose}
          className="absolute right-4 top-4 p-1 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors"
        >
          <X size={18} />
        </button>

        <div className="p-6">
          {/* ICON & TITLE */}
          <div className="flex flex-col items-center text-center">
            <div className="w-12 h-12 bgf-red-50 text-red-600 rounded-full flex items-center justify-center mb-4">
              <Trash2 size={24} />
            </div>
            <h2 className="text-xl font-bold text-gray-900 leading-tight">
              {title}
            </h2>
            <p className="mt-2 text-sm text-gray-500">
              {description}
            </p>
          </div>

          {/* ACTIONS */}
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <button
              onClick={onClose}
              disabled={loading}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-200 rounded-xl hover:bg-gray-50 transition-all active:scale-95 disabled:opacity-50"
            >
              Batal
            </button>

            <button
              onClick={onConfirm}
              disabled={loading}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-red-600 rounded-xl hover:bg-red-700 shadow-sm shadow-red-200 transition-all active:scale-95 disabled:opacity-50 flex justify-center items-center gap-2"
            >
              {loading ? (
                <>
                  <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  Memproses...
                </>
              ) : (
                "Ya, Hapus"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body // Merender tepat di bawah <body>
  );
}